var k = Object.defineProperty;
var l = (o, e, t) => e in o ? k(o, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : o[e] = t;
var u = (o, e, t) => l(o, typeof e != "symbol" ? e + "" : e, t);
import { Store as m } from "@tanstack/store";
const h = (o) => [...o].sort(
  (e, t) => t.priority - e.priority || new Date(t.inserted_at).getTime() - new Date(e.inserted_at).getTime()
), g = (o) => `/v1/users/${o}/guides`;
class p {
  constructor(e, t, s = {}) {
    u(this, "store");
    // Phoenix channels for real time guide updates over websocket
    u(this, "socket");
    u(this, "socketChannel");
    u(this, "socketChannelTopic");
    u(this, "socketEventTypes", ["guide.added", "guide.updated", "guide.removed"]);
    this.knock = e, this.channelId = t, this.targetParams = s, this.store = new m({
      guides: [],
      queries: {}
    });
    const { socket: r } = this.knock.client();
    this.socket = r, this.socketChannelTopic = `guides:${t}`, this.knock.log("[Guide] Initialized a guide client");
  }
  async fetch(e) {
    this.knock.failIfNotAuthenticated(), this.knock.log("[Guide] Loading all eligible guides");
    const t = this.buildQueryParams(e == null ? void 0 : e.filters), s = this.formatQueryKey(t), r = this.store.state.queries[s];
    if (r)
      return r;
    this.store.setState((i) => ({
      ...i,
      queries: { ...i.queries, [s]: { status: "loading" } }
    }));
    let n;
    try {
      const i = await this.knock.user.getGuides(this.channelId, t);
      n = { status: "ok" }, this.store.setState((a) => ({
        ...a,
        // For now assume a single fetch to get all eligible guides. When/if
        // we implement incremental loads, then this will need to be a merge
        // and sort operation.
        guides: i.entries.map((d) => this.localCopy(d)),
        queries: { ...a.queries, [s]: n }
      }));
    } catch (i) {
      n = { status: "error", error: i }, this.store.setState((a) => ({
        ...a,
        queries: { ...a.queries, [s]: n }
      }));
    }
    return n;
  }
  subscribe() {
    if (!this.socket) return;
    this.knock.failIfNotAuthenticated(), this.knock.log("[Guide] Subscribing to real time updates"), this.socket.isConnected() || this.socket.connect(), this.socketChannel && this.unsubscribe();
    const e = { ...this.targetParams, user_id: this.knock.userId }, t = this.socket.channel(this.socketChannelTopic, e);
    for (const s of this.socketEventTypes)
      t.on(s, (r) => this.handleSocketEvent(r));
    ["closed", "errored"].includes(t.state) && t.join(), this.socketChannel = t;
  }
  unsubscribe() {
    if (this.socketChannel) {
      this.knock.log("[Guide] Unsubscribing from real time updates");
      for (const e of this.socketEventTypes)
        this.socketChannel.off(e);
      this.socketChannel.leave(), this.socketChannel = void 0;
    }
  }
  handleSocketEvent(e) {
    const { event: t, data: s } = e;
    switch (t) {
      case "guide.added":
        return this.addGuide(e);
      case "guide.updated":
        return s.eligible ? this.replaceOrAddGuide(e) : this.removeGuide(e);
      case "guide.removed":
        return this.removeGuide(e);
      default:
        return;
    }
  }
  //
  // Store selector
  //
  select(e, t = {}) {
    return e.guides.filter((s) => !(t.type && t.type !== s.type || t.key && t.key !== s.key));
  }
  //
  // Engagement event handlers
  //
  // Make an optimistic update on the client side first, then send an engagement
  // event to the backend.
  //
  async markAsSeen(e, t) {
    this.knock.log(
      `[Guide] Marking as seen (Guide key: ${e.key}, Step ref:${t.ref})`
    );
    const s = this.setStepMessageAttrs(e.key, t.ref, {
      seen_at: (/* @__PURE__ */ new Date()).toISOString()
    });
    if (!s) return;
    const r = {
      ...this.buildEngagementEventBaseParams(e, s),
      content: s.content,
      data: this.targetParams.data,
      tenant: this.targetParams.tenant
    };
    return this.knock.user.markGuideStepAs(
      "seen",
      r
    ), s;
  }
  async markAsInteracted(e, t, s) {
    this.knock.log(
      `[Guide] Marking as interacted (Guide key: ${e.key}, Step ref:${t.ref})`
    );
    const r = (/* @__PURE__ */ new Date()).toISOString(), n = this.setStepMessageAttrs(e.key, t.ref, {
      read_at: r,
      interacted_at: r
    });
    if (!n) return;
    const i = {
      ...this.buildEngagementEventBaseParams(e, n),
      metadata: s
    };
    return this.knock.user.markGuideStepAs("interacted", i), n;
  }
  async markAsArchived(e, t) {
    this.knock.log(
      `[Guide] Marking as archived (Guide key: ${e.key}, Step ref:${t.ref})`
    );
    const s = this.setStepMessageAttrs(e.key, t.ref, {
      archived_at: (/* @__PURE__ */ new Date()).toISOString()
    });
    if (!s) return;
    const r = this.buildEngagementEventBaseParams(e, s);
    return this.knock.user.markGuideStepAs(
      "archived",
      r
    ), s;
  }
  //
  // Helpers
  //
  localCopy(e) {
    const t = this, s = { ...e };
    return s.steps = e.steps.map(({ message: r, ...n }) => {
      const i = {
        ...n,
        message: { ...r },
        markAsSeen() {
          if (!this.message.seen_at)
            return t.markAsSeen(s, this);
        },
        markAsInteracted({ metadata: a } = {}) {
          return t.markAsInteracted(s, this, a);
        },
        markAsArchived() {
          if (!this.message.archived_at)
            return t.markAsArchived(s, this);
        }
      };
      return i.markAsSeen = i.markAsSeen.bind(i), i.markAsInteracted = i.markAsInteracted.bind(i), i.markAsArchived = i.markAsArchived.bind(i), i;
    }), s;
  }
  buildQueryParams(e = {}) {
    const t = { ...this.targetParams, ...e };
    let s = Object.fromEntries(
      Object.entries(t).filter(
        ([r, n]) => n != null
      )
    );
    return s = s.data ? { ...s, data: JSON.stringify(s.data) } : s, s;
  }
  formatQueryKey(e) {
    const s = Object.keys(e).sort().map(
      (n) => `${encodeURIComponent(n)}=${encodeURIComponent(e[n])}`
    ).join("&"), r = g(this.knock.userId);
    return s ? `${r}?${s}` : r;
  }
  setStepMessageAttrs(e, t, s) {
    let r;
    return this.store.setState((n) => {
      const i = n.guides.map((a) => {
        if (a.key !== e) return a;
        const d = a.steps.map((c) => (c.ref !== t || (c.message = { ...c.message, ...s }, r = c), c));
        return { ...a, steps: d };
      });
      return { ...n, guides: i };
    }), r;
  }
  buildEngagementEventBaseParams(e, t) {
    return {
      message_id: t.message.id,
      channel_id: e.channel_id,
      guide_key: e.key,
      guide_id: e.id,
      guide_step_ref: t.ref
    };
  }
  addGuide({ data: e }) {
    const t = this.localCopy(e.guide);
    this.store.setState((s) => ({ ...s, guides: h([...s.guides, t]) }));
  }
  replaceOrAddGuide({ data: e }) {
    const t = this.localCopy(e.guide);
    this.store.setState((s) => {
      let r = !1;
      const n = s.guides.map((i) => i.key !== t.key ? i : (r = !0, t));
      return {
        ...s,
        guides: h(r ? n : [...n, t])
      };
    });
  }
  removeGuide({ data: e }) {
    this.store.setState((t) => {
      const s = t.guides.filter((r) => r.key !== e.guide.key);
      return { ...t, guides: s };
    });
  }
}
export {
  p as KnockGuideClient,
  g as guidesApiRootPath
};
//# sourceMappingURL=client.mjs.map
